import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Form } from "antd";
import { Button, Card, CardFooter, Input, Select } from "@rumbledirect/ui";

interface TaskFormCardProps {
  mutation: UseMutationResult<null, Error, Task, unknown>;
  loading?: boolean;
  initialValues?: Task;
  title?: string;
  buttonText?: string;
  userOptions?: { label: string; value: string }[];
}

export const TaskFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "Taak aanmaken",
  buttonText = "Aanmaken",
  userOptions = [],
}: TaskFormCardProps) => {
  // Map initial values so the Select for assignee receives the IRI instead of numeric/id value
  const formInitialValues = initialValues
    ? {
        ...initialValues,
        assignee: initialValues.assignee
          ? initialValues.assignee?.iri
          : undefined,
      }
    : undefined;
  return (
    <Card loading={loading} title={title}>
      <Form
        onFinish={mutation.mutate}
        layout="vertical"
        initialValues={formInitialValues}
      >
        <Form.Item
          rules={[{ required: true, message: "Dit veld is verplicht." }]}
          label="Beschrijf taak"
          name="description"
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[
            {
              max: 160,
              message: "Extra notitie mag niet langer zijn dan 160 tekens.",
            },
          ]}
          label="Extra notitie taak"
          name="note"
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item name="assignee" label="Toewijzen aan gebruiker">
          <Select
            placeholder="Selecteer een gebruiker (optioneel)"
            options={userOptions}
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item name="priority" label="Prioriteit">
          <Select
            defaultValue="normal"
            options={[
              {
                value: "normal",
                label: "Normaal",
              },
              {
                value: "urgent",
                label: "Spoed",
              },
            ]}
          />
        </Form.Item>

        <CardFooter>
          <Button loading={mutation.isPending} type="primary" htmlType="submit">
            {buttonText}
          </Button>
        </CardFooter>
      </Form>
    </Card>
  );
};
